import { useState, useEffect } from "react";
import "../../pages/SalesMasterPages/AddLead/AddLead.css";
import React from "react";
import axios from "axios";
import SearchIcon from "@mui/icons-material/Search";

const TaskAssignedToMe = () => {
  const baseAPI = process.env.REACT_APP_API_URL;
  const [taskAssignedResponse, settaskAssignedResponse] = useState([]); 

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {
      axios
        .get(`${baseAPI}userget/GetTaskDetailInfoToMe`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.data &&
            response.data.data.length > 0
          ) {
            settaskAssignedResponse(response.data.data);
          } else {
            return null;
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, []);

  const formatDate = (isoDate) => {
    if (!isoDate) return "";

    const date = new Date(isoDate);
    if (isNaN(date)) return "";

    const day = date.toLocaleString("en-GB", { day: "2-digit" });
    const month = date.toLocaleString("en-GB", { month: "short" });
    const year = date.getFullYear();
    const time = date.toLocaleString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    return `${day} ${month} ${year} | ${time}`;
  };

  function nextPage1(task_id,assigned) {
    const url = `/viewtaskassigneddetail?task_id=${task_id}&assigned=${assigned}`;
    window.open(url, "_blank");
  }

  return (
    <>
       <div
    className="container-fluid container-AddLead"
    style={{ backgroundColor: "white" }}
  >
    {taskAssignedResponse && taskAssignedResponse.length > 0 ? (
      <div
        style={{
          border: "1px solid #DEE2E6",
          borderRadius: "10px",
          marginBottom: "20px",
        }}
      >
        <table className="paymentHistory">
          <thead>
            <tr style={{ backgroundColor: "#F0EBFF" }}>
              <th>Task ID</th>
              <th>Created On</th>
              <th>Due Date</th>
              <th>Task Title</th>
              <th>Assigned By</th>
              <th>Priority</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {taskAssignedResponse.map((item, index) => (
              <tr key={index}>
                <td>{item.task_id}</td>
                <td>{formatDate(item.created_on)}</td>
                <td>{formatDate(item.due_date)}</td>
                <td>{item.task_title}</td>
                <td>{item.AssignedByName}</td>
                <td>{item.task_priority}</td>
                <td style={{ textAlign: "center" }}>
                  <button
                    onClick={() => nextPage1(item.task_id,"to_me")}
                    style={{
                      height: "30px",
                      width: "38px",
                      backgroundColor: "#5B489D",
                    }}
                  >
                    <SearchIcon style={{ color: "white" }} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ) : (
      <div style={{ textAlign: "center", marginTop: "20px", color: "#888" }}>
        No tasks assigned.
      </div>
    )}
  </div>
    </>
  );
};

export default TaskAssignedToMe;
